import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Identification from './views/identification/Index.vue'
import Agreement from './views/agreement/index.vue'
import StripePay from './views/stripe/Pay.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          name: 'home',
          path: '',
          redirect: 'payment',
        },
        {
          path: '/identification/:openOrderId',
          name: 'Identification',
          component: Identification,
        },
        {
          path: '/identification-agreement/:openOrderId',
          name: 'Agreement',
          component: Agreement,
        },
        {
          path: '/payment',
          name: 'StripePay',
          component: StripePay,
        }],
    },
  ],
})
